"use client"

import { useEffect } from "react"
import { trackEvent } from "@/lib/analytics"

// Thin client island for the "comparison_page_viewed" analytics call.
// Extracted from ComparisonPage so the surrounding hero/H1/table can render
// as a server component — Googlebot sees the content in the initial HTML
// instead of waiting for client hydration. Renders nothing.
export function ComparisonPageTracker({ competitor }: { competitor: string }) {
  useEffect(() => {
    trackEvent("comparison_page_viewed", { competitor })
  }, [competitor])

  return null
}
